module.exports = __webpack_public_path__ + "img/小图1.dd6b735b.png";